import axios, {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {BucketImageDocType} from '../../../models/config/BucketImageDocType';
import {ResponseError} from '../../../models/common/Response';

export function useAddBucketImageDocTypeMapping(
    options?: UseMutationOptions<
        BucketImageDocType,
        AxiosError<ResponseError>,
        BucketImageDocType
    >
) {
    return useMutation({
        mutationFn: (request) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.post('/v1/configuration/lis/bucket-image-doc-type-mapping', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
        },
        ...options,
    });
}